<template>
  <div class="intro-title">
    <div class="title-item" v-for="(item, index) in titles" :key="index" v-html="item" />
  </div>
</template>

<script>
  export default {
    name: 'intro-title',

    props: {
      titles: {
        type: Array,
        default: () => []
      }
    }
  }
</script>

<style lang="scss" scoped>
  .intro-title {
    padding-left: 8px;
    padding-bottom: 6px;

    .title-item {
      font-size: 16px;
      font-weight: bold;
      line-height: 22px;
      color: #08346a;

      ::v-deep span {
        color: #ff6e08;
      }
    }
  }
</style>
